export default "__VITE_ASSET__ChC5_gLE__"